import React from 'react'
import { asField } from 'informed'

const withField = WrapedComponent => asField(({ noError, visible = true, ...props }) =>
	<WrapedComponent error={props.fieldState.error} {...props}/>
)

export default withField
